import { WAPP_COMMUNICATE_CORE_OPEN_IMAGE_MODAL } from '@weblite/wapp-communication-action/core'
import { ImageDetails, showImageViewerModal } from '$comp/modals/image-viewer'
import { wappSub } from '$func/subscription'

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_OPEN_IMAGE_MODAL,
  ({ src, width, height }) => {
    if (!src) return

    showImageViewerModal({
      media: { src, attachment: { width, height } } as ImageDetails,
    })
  },
)
